<template>
  <Selector :options="_options">
    <template #header>
      <div flex="~ wrap" space-x-12>
        <div class="btn">xxx</div>
        <div class="btn">xxx</div>
        <div class="btn">xxx</div>
        <div class="btn">xxx</div>
        <div class="btn">xxx</div>
        <div class="btn">xxx</div>
        <div class="btn">xxx</div>
        <div class="btn">xxx</div>
        <div class="btn">xxx</div>
      </div>
    </template>
  </Selector>
</template>

<script setup>
import { computed, ref } from 'vue';
import Selector from './Selector.vue'

const props = defineProps({
  options: Function
})

const type = ref('')

function _options(kw) {
  return props.options(kw, type.value)
}
</script>

<style scoped>
.btn {
  @apply px-12 rd-full b-(1 solid #00000015) hover:bg-#00000010 cursor-pointer;
}
</style>